// extracted by mini-css-extract-plugin
export default {"container":"H0-z","list":"I0-z"};